import React from "react";
import { Filter, useTranslate } from "react-admin";

import { DateInput } from "../../../components/inputs";
import { NumberInputEx } from "../../../components/inputs";
import { SelectEnumInput } from "../../../components/inputs/SelectEnumInput";
import { TerminalSettingPerDateType } from "../../../entities/TerminalSettingPerDateType";

export const TerminalSettingPerDateFilters = (props) => {
	const translate = useTranslate();
	const t = (source) => translate(`resources.terminal-setting-per-date.fields.${source}`);

	return (
		<Filter {...props}>
			<SelectEnumInput
				source="type"
				enumObj={TerminalSettingPerDateType}
				enumName="terminal_setting_per_date_type"
				resettable
			/>
			<DateInput source="date_from" />
			<DateInput source="date_to" />
			<NumberInputEx source="value" type="float" digitsCount={5} resettable />
		</Filter>
	);
};
